import { render, staticRenderFns } from "./JoursOuvresAdmin.vue?vue&type=template&id=bf5bde26&scoped=true"
import script from "./JoursOuvresAdmin.vue?vue&type=script&lang=js"
export * from "./JoursOuvresAdmin.vue?vue&type=script&lang=js"
import style0 from "./JoursOuvresAdmin.vue?vue&type=style&index=0&id=bf5bde26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5bde26",
  null
  
)

export default component.exports